import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3opsa00um8: FaireBrandEntity = {
  token: "b_3opsa00um8",
  type: "brand",
  name: "Curious Elixirs",
  avatarUrl:
    "https://cdn.faire.com/fastly/2c76fe4879cb45a8b6f43e3b0ae31dde3d83e5abe521b3d0ad6dcb06339a1035.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a9e855c8cc0f1a9837fa557f45021f7883db78cb637af92f9e42d29fd5486240.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2c76fe4879cb45a8b6f43e3b0ae31dde3d83e5abe521b3d0ad6dcb06339a1035.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a9e855c8cc0f1a9837fa557f45021f7883db78cb637af92f9e42d29fd5486240.jpeg",
  location: "Newburgh, NY, USA",
  minimumOrderDollars: 166,
  rating: 4.6,
  reviewCount: 81,
  isInsider: true,
  description:
    "#ShakenNotSlurred: Curious Elixirs are booze-free craft cocktails, infused with adaptogens to help you unwind. Handcrafted in NY's Hudson Valley with organic juices, herbs, botanicals, and no added sugar.\n\nOur mission is to transform how we drink socially by making the world's best non-alcoholic beverages.  Are you Curious? ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:37.261Z",
    importedBy: "entity-db-cli",
  },
};
